<template>
  <div class="container">
    <div class="row pb-7">
      <div class="col">
        <h2>Anhänge</h2>
      </div>
    </div>
    <div class="flex flex-row flex-wrap">
      <button
        v-for="{ name, typ, link } in dokumente"
        :key="name"
        class="flex w-full items-center border-0 bg-white p-5 mb-5 rounded-sm outline-[#d8d8d8] shadow-[0_3px_10px_rgb(0_0_0/0.2)] transition-all duration-200 ease-in-out hover:bg-[#fcfcfc] hover:shadow-[0_1px_6px_rgb(0_0_0/0.3)] hover:no-underline hover:translate-y-[3px] active:bg-[#fcfcfc] active:shadow-[0_1px_6px_rgb(0_0_0/0.3)] active:no-underline active:translate-y-[3px] xl:mr-[15px] xl:w-[calc(25%-11.25px)]"
        @click="setMediaRef(link, name)"
      >
        <div class="mr-2.5 flex-[0_0_1.33rem] text-blue-500">
          <i class="far fa-lg fa-file-alt" />
        </div>
        <div class="flex-auto font-bold text-[#333] no-underline antialiased">
          {{ typ }}
        </div>
      </button>
    </div>

    <div class="flex flex-row flex-wrap">
      <a
        v-for="{ url, titel } in links"
        :key="url"
        :href="url"
        target="_blank"
        class="flex w-full items-center border-0 bg-white p-5 mb-5 rounded-sm outline-[#d8d8d8] shadow-[0_3px_10px_rgb(0_0_0/0.2)] transition-all duration-200 ease-in-out hover:bg-[#fcfcfc] hover:shadow-[0_1px_6px_rgb(0_0_0/0.3)] hover:no-underline hover:translate-y-[3px] active:bg-[#fcfcfc] active:shadow-[0_1px_6px_rgb(0_0_0/0.3)] active:no-underline active:translate-y-[3px] xl:mr-[15px] xl:w-[calc(25%-11.25px)]"
      >
        <div class="mr-2.5 flex-[0_0_1.33rem] text-blue-500">
          <i class="fas fa-md fa-external-link-alt" />
        </div>
        <div class="flex-auto font-bold text-[#333] no-underline antialiased">
          {{ titel }}
        </div>
      </a>
    </div>
  </div>
</template>

<script setup lang="ts">
import type { Dokument, Link } from '@/bedarf/types/dtos';
import { useMediaPreviewStore } from "@/application/store/mediaPreviewStore";

interface Props {
  links?: Link[]
  dokumente?: Dokument[]
}

withDefaults(defineProps<Props>(), {
  links: () => [],
  dokumente: () => [],
});

const { setMediaRef } = useMediaPreviewStore();
</script>
